<div class="toast-area mt-4" id="toastArea">
    <div class="toast" *ngFor="let item of latestTransactions; trackBy: trackByTx">
        <div class="av"><img class="logo img-fluid mwx-34" src="/assets/images/png/token-icon-light.png" alt="SeerDex Logo"
                loading="lazy" />
        </div>
        <div>
            <div class="ln1">{{item.user | trimAddress}}</div>
            <div class="ln2" [innerHTML]="'latest_purchase.purchase_text' | translate : { amount: ((item.usdEq || 0) | number:'1.2-2')}"></div>
        </div>
        <div class="time">{{ getRelativeTime(item.timestamp) }}</div>
    </div>
</div>